
<template>
  <!--制卡记录-->
  <div>
    <x-tabula
      :dataSource="dataSource"
      rowKey="card_id"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :deleteParam="deleteParam"
      :rowSelection="false"
    >
    </x-tabula>
  </div>
</template>

<script>
import mixin from '../../js/mixins';
export default {
  mixins: [mixin.fetchSelect],
  name: 'cardRecord',
  data () {
    return {
      searchList: [
        { props: ['community_id'], placeholder: '小区名称', options: [], inputType: 'select' },
        { props: ['mobile'], placeholder: '手机号', options: [], inputType: 'input' },
        { props: ['keywords'], placeholder: '卡号', options: [], inputType: 'input' },
        { props: ['status'], placeholder: '状态', options: this.$store.state.statusList, inputType: 'select' },
        { props: ['is_copy'], placeholder: '是否复制', options: this.$store.state.booleanList, inputType: 'select' },
        { props: ['area_id'], placeholder: '省市', options: [], inputType: 'cascader', changeOnSelect: true },
        { props: ['property_id'], placeholder: '物业', options: [], inputType: 'select' },
        { props: ['is_encrypt'], placeholder: '制卡模式', options: this.$store.state.makeCardList, inputType: 'select' },
        { props: ['member_type'], placeholder: '用户类型', options: [{label: '用户', value: 1}, {label: '管家', value: 2}], inputType: 'select' },
        { props: ['create_date'], placeholder: ['创建时间', '创建时间'], options: [], inputType: 'datePick' }
      ],
      tableOptList: [],
      rowOptList: [
        { text: '', customRender: true, handle: (row) => this.triggerStatus(row), key: 'status' },
        { text: '删除', handle: (row) => this.$children[0].showDeleteConfirm(row), key: 'delete' }
      ],
      columns: [
        { title: 'ID', dataIndex: 'card_id', align: 'left', width: '' },
        { title: '卡号', dataIndex: 'cardno', align: 'left', width: '' },
        { title: '制卡模式', dataIndex: 'encrypt_desc', align: 'left', width: '' },
        { title: '小区', dataIndex: 'community_name', align: 'left', width: '' },
        { title: '手机号', dataIndex: 'mobile', align: 'left', width: '' },
        { title: '持卡人', dataIndex: 'nick_name', align: 'left', width: '' },
        { title: '用户类型', dataIndex: 'member_typedesc', align: 'left', width: '' },
        { title: '添加时间', dataIndex: 'create_time', align: 'left', width: '' },
        { title: '备注', dataIndex: 'remark', align: 'left', width: '' },
        { title: '是否复制', dataIndex: 'is_copy_desc', align: 'left', width: '' },
        { title: '状态', dataIndex: 'status_desc', align: 'left', width: '' },
        { title: '操作', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'action'} }
      ],
      dataSource: [],
      searchParams: {
        community_id: '',
        mobile: '',
        keywords: '',
        status: '',
        area_id: '',
        property_id: '',
        is_encrypt: '',
        member_type: '',
        create_date: '',
        is_copy: ''
      },
      listApi: {
        url: '/card',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      },
      deleteParam: {
        url: '/card',
        param: { pk_key: 'card_id', pk_val: '' },
        title: '制卡记录',
        key: 'cardno'
      }
    };
  },
  mounted () {
    this.getSelect();
  },
  methods: {
    getSelect () {
      this.communitySelect(0, 'searchList', 1);
      this.propertySelect(6);
      this.regionSelect(5);
    },
    triggerStatus (row) {
      let status;
      row.status === 0 ? status = 1 : status = 0;
      this.$post({
        url: '/card',
        params: {
          card_id: row.card_id,
          status: status
        }
      }).then((res) => {
        this.$message.success('状态切换成功！');
        this.$children[0].getTableList();
      });
    },
    resHandle (res) {
      console.log('处理list返回数据: ');
      return res;
    },
    searchHandle (selectData) {
      console.log('处理搜索数据: ', selectData);
      // return selectData;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/device/cardRecord.vue